const Searchlinks = (hint) => {

    const links = [
        {
            title: "Eazistey home page",
            description: "Eazistey landing page.check out our home page",
            link: "/",
            id: 1
        },
        {
            title: "Eazistey Login page",
            description: "Login page.Login to get more features",
            link: "/nav/myproperties",
            id: 2
        },
        {
            title: "Eazistey Register page",
            description: "Sign up or register to get more amazing features on Eazistey",
            link: "/nav/myproperties",
            id: 3
        },
        {
            title: "Property listings",
            description: "View all sorts of houses in your vicinity.From bedsitter,singleroom,1 bedroom to apartments",
            link: "/nav/hostels",
            id: 4
        },
        {
            title: "Frequently asked questions(faq's)",
            description: "Get answers to all your concerns on our faq's section",
            link: "/nav/faqs",
            id: 5
        },
        {
            title: "Eazistey help",
            description: "Get help by contacting us and we'll respond asap",
            link: "/nav/help",
            id: 6
        },
        {
            title: "Chats",
            description: "Get a taste of our realtime chat service",
            link: "/nav/chats",
            id: 7
        },
        {
            title: "User account",
            description: "Edit your profile and account",
            link: "/nav/useraccount",
            id: 8
        },
        {
            title: "Services & Businesses",
            description: "View businesses and services around you",
            link: "/nav/services",
            id: 9
        }
    ]


    var result = [];
    const th = hint.toLowerCase();

    for (var i in links) {
        if (links[i].description.toLowerCase().match(th)) {
            result.push(links[i]);
        }
    }
    return result;

}

export default Searchlinks;